import MeetRegistrationEdit from 'components/admin/MeetRegistration/MeetRegistrationEdit';
import React from 'react';
import { useParams } from 'react-router-dom';
import MetaTags from 'components/common/MetaTags';

const MeetRegistration = () => {
  const { clubId, meetId } = useParams();
  return (
    <>
      <MetaTags title="SplitFast | Meet Registration" />
      <MeetRegistrationEdit
        clubId={clubId}
        meetId={meetId}
      ></MeetRegistrationEdit>
    </>
  );
};

export default MeetRegistration;
